var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "link__icon" }, [
    _c(
      "svg",
      {
        staticClass: "link__icon-circle",
        attrs: {
          width: "40",
          height: "40",
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }
      },
      [
        _c("g", { attrs: { mask: "url(#maskLink)" } }, [
          _c("path", { attrs: { d: "M0 0H40V40H0V30H8V10H0V0Z" } })
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "svg",
      {
        staticClass: "link__icon-svg link__icon-hyphen",
        attrs: { width: "8", height: "8" }
      },
      [
        _c("use", {
          attrs: { "xlink:href": "/webicons/sprite.svg#i-link-hyphen" }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "svg",
      {
        staticClass: "link__icon-svg link__icon-arrow",
        attrs: { width: "5", height: "8" }
      },
      [
        _c("use", {
          attrs: { "xlink:href": "/webicons/sprite.svg#i-arr-right" }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }